import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Divider,
  Drawer, Dropdown, Popconfirm, Table, Tag,
  Tooltip,
} from 'antd';
import PropTypes from 'prop-types';
import {
  FilterOutlined, EditOutlined, ExclamationCircleFilled, UpCircleTwoTone,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { toISTDate, entityNameEnum, filterTypeEnums } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import TenantActions from '@Actions/tenantActions';
import ExpenseActions from '@Actions/purchase/expense/expenseActions';
import SellerActions from '@Actions/sellerActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import SelectSeller from '@Components/Common/SelectSeller';
import searchIcon from '@Images/icons/icon-search.png';
import Busy from '@Images/admin/integrations/busy.png';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ExpenseForm from '../ExpenseForm';
import ViewExpense from '../ViewExpense';
import BusyIntegrationActions from '../../../../actions/integrations/busyIntegrationAction';
import PRZText from '../../../Common/UI/PRZText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faPen } from '@fortawesome/free-solid-svg-icons';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

function ExpenseHome({
  getExpenseLoading, getExpense, user, history, expense, sellers, MONEY, pushExpenseToBusy, pushExpenseToBusyLoading, getSellers
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedSeller, setSelectedSeller] = useState('');
  const [selectedExpense, setSelectedExpense] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  // const [open, setOpen] = useState(false);
  const [call, setCall] = useState(false);
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [showUpdateExpenseModal, setShowUpdateExpenseModal] = useState(false);
  const [showViewExpense, setShowViewExpense] = useState(false);
  // Saved Filter View States
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  // common 
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray?.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }
  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'vendor',
        filter_value: Helpers.getValueFromUrl('vendor') || '',
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }
  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'vendor',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },

  ], []);
  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.EXPENSES,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);
  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Helpers.getValueFromUrl('limit') || limit);
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      // setIsUserReady(true);
      setShowAddExpenseModal(Helpers.getValueFromUrl('toCreate') && Boolean(Helpers.getValueFromUrl('toCreate')));
      setSelectedFilterView(systemDefaultUserView);
    }
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');
      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);
      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        // common state
        setCurrentlyAppliedFilters(appliedFiltersFromURL);
        // temp state
        setCurrentPage(tempFilterValues.page || 1);
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedSeller(Number(tempFilterValues.vendor) ? Number(tempFilterValues.vendor) : "");
        getSellers('', user?.tenant_info?.tenant_id, 1, 1000, '', () => { }, true);

      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  const pushParamsToUrl = (page, limit, word, status, currentTenant, startDate, endDate, department, customer, seller) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (word) url += `&keyword=${word}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (status) url += `&status=${status}`;
    if (department) url += `&department_id=${department}`;
    if (customer) url += `&customer_id=${customer}`;
    if (seller) url += `&vendor=${seller}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedCustomer, selectedSeller, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getExpense(
        selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.EXPENSE, Helpers.permissionTypes.READ)?.join(','), '',
        Helpers.getValueFromUrl('customer_id'),
        Helpers.getValueFromUrl('vendor'),
        Helpers.getValueFromUrl('department_id'),
        Helpers.getValueFromUrl('page'),
        Helpers.getValueFromUrl('limit'),
        Helpers.getValueFromUrl('status'),
        Helpers.getValueFromUrl('startDate'),
        Helpers.getValueFromUrl('endDate'),
        Helpers.getValueFromUrl('keyword'),
      );
    }
  }, [currentPage, limit, searchKeyword, selectedStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedCustomer, selectedSeller, call]);

  const incomingPaymentsColumns = () => {
    const payoutColumns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.exp_number || 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Mode" />
                  )}
                >
                  <PRZText
                    text={(record?.paid_through_account_details?.account_name === 'PICE' ? 'ONLINE' : record?.paid_through_account_details?.account_name) || 'CASH'}
                    style={{
                      color: 'rgb(40, 40, 43)',
                    }}
                    className="mobile-list__card__status"
                  />
                </Tooltip>
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                {record?.seller_info?.internal_slr_code && (
                  <div className="mobile-list__card_item-name_wrapper">
                    <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                      <PRZText
                        className="mobile-list__card_item-name"
                        text={`${record?.seller_info?.internal_slr_code} - ${record?.seller_info?.seller_name}`}
                      />
                    </Link>
                  </div>
                )}
                {record?.customer_info?.internal_cust_code && (
                  <div className="mobile-list__card_item-name_wrapper">
                    <Link to={`/sales/customer/view/${record?.customer_id}`} target="_blank">
                      <PRZText
                        className="mobile-list__card_item-name"
                        text={`${record?.customer_info?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                      />
                    </Link>
                  </div>
                )}
                <PRZText
                  text={`Location - ${record?.tenant_info?.tenant_name} (${record?.department_name || 'N/A'})`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Payment Date - ${toISTDate(record?.payment_date).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Expense Title - ${(record?.expense_title)}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Expense Account - ${(record?.account_name)}`}
                  className="mobile-list__card_item-details"
                />
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Amount" />
                  )}
                >
                  <PRZText
                    text={MONEY((record.grand_total || '0'), record?.org_currency_info?.currency_code)}
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Expense Type" />
                  )}
                >
                  <PRZText
                    text={record?.expense_type}
                    style={{
                      color: 'rgb(40, 40, 43)',
                    }}
                    className="mobile-list__card_footer__other-status"
                  />
                </Tooltip>
              </div>
              <div className="mobile-list__card_footer-right">
                <div className="mobile-list__card_footer__actions-button_wrapper">
                  <div className="card_footer__actions-button">
                    {['ISSUED'].includes(record.status) && record?.busy_location_name && (
                      <Popconfirm
                        placement="topRight"
                        title={(record?.busy_sync_error ? record?.busy_sync_error : (record?.busy_voucher_id ? 'Expense is already synced with Busy' : 'Expense is not synced with Busy'))}
                        onConfirm={() => pushExpenseToBusy(
                          { expense_id: record?.expense_id },
                          () => setCall(!call),
                        )}
                        okText={(!record?.busy_sync_error && !record?.busy_voucher_id) ? 'Sync' : 'Sync Again'}
                        okButtonProps={{
                          loading: pushExpenseToBusyLoading,
                        }}
                        cancelText="Cancel"
                        icon={record?.busy_sync_error ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                      >
                        <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                          <img
                            src={Busy}
                            alt="busy"
                            className="img-tally card_footer__actions-button_image"
                          />
                          {(!record?.busy_sync_at || record?.busy_sync_error) && <div className={`tally-corner-icon actions-button__corner-icon ${record?.busy_sync_error && 'red-indicator'}`}>{!record?.busy_sync_error && <UpCircleTwoTone twoToneColor="#52c41a" />}</div>}
                        </div>
                      </Popconfirm>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'EXPENSE #',
        render: (record) => <div className="min-width-70">{record?.exp_number}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'left',
        // className: !visibleColumns.EXPENSE_ID.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.LOCATION.visible ? 'display-none' : '',
      },
      {
        title: 'EXPENSE TITLE',
        render: (record) => <div className="min-width-100">{record?.expense_title}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.EXPENSE_TITLE.visible ? 'display-none' : '',
      },
      {
        title: 'EXPENSE ACCOUNT',
        render: (record) => <div className="min-width-100">{record?.account_name}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.EXPENSE_ACCOUNT_ID.visible ? 'display-none' : '',
      },
      {
        title: 'EXPENSE TYPE',
        render: (record) => <div className="min-width-100">{record?.expense_type}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.EXPENSE_TYPE.visible ? 'display-none' : '',
      },
      {
        title: 'DATE',
        render: (record) => (
          <div className="min-width-50">
            {toISTDate(record?.payment_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.DATE.visible ? 'display-none' : '',
      },
      {
        title: 'VENDOR',
        render: (text, record) => (record?.seller_info ? (
          <div className="associated-entity min-width-70">
            <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
              {`${record?.seller_info?.internal_slr_code} - ${record?.seller_info?.seller_name}`}
            </Link>
          </div>
        ) : '-'),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.VENDOR.visible ? 'display-none' : '',
      },
      {
        title: 'CUSTOMER',
        render: (text, record) => (
          <div className="min-width-85">
            {record?.customer_info ? (
              <div className="associated-entity">
                <Link to={`/sales/customer/view/${record?.customer_id}`} target="_blank">
                  {`${record?.customer_info?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                </Link>
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.CUSTOMER.visible ? 'display-none' : '',
      },

      {
        title: 'MODE',
        render: (text, record) => (
          <div className="min-width-50">
            {(record?.paid_through_account_details?.account_name === 'PICE' ? 'ONLINE' : record?.paid_through_account_details?.account_name) || 'CASH'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.MODE.visible ? 'display-none' : '',

      },
      {
        title: 'AMOUNT',
        render: (text, record) => (
          <div className="min-width-70">
            {MONEY(record?.grand_total)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns.AMOUNT.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED BY',
        render: (record) => (
          <div className="min-width-85">
            {dayjs(record?.created_at).format('DD/MM/YYYY')}
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: '',
        key: 'action',
        className: 'list__actions-column',
        render: (record) => (
          <div className="list__actions">
            <div className="list__actions-button img-tally__wrapper">
              {['ISSUED'].includes(record.status) && record?.busy_location_name && (
                <Popconfirm
                  placement="topRight"
                  title={(record?.busy_sync_error ? record?.busy_sync_error : (record?.busy_voucher_id ? 'Expense is already synced with Busy' : 'Expense is not synced with Busy'))}
                  onConfirm={() => pushExpenseToBusy(
                    { expense_id: record?.expense_id },
                    () => setCall(!call),
                  )}
                  okText={(!record?.busy_sync_error && !record?.busy_voucher_id) ? 'Sync' : 'Sync Again'}
                  okButtonProps={{
                    loading: pushExpenseToBusyLoading,
                  }}
                  cancelText="Cancel"
                  icon={record?.busy_sync_error ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                >

                  <img
                    src={Busy}
                    alt="busy"
                    className="img-tally"
                  />
                  {(!record?.busy_sync_at || record?.busy_sync_error) && <div className={`tally-corner-icon  ${record?.busy_sync_error && 'red-indicator'}`}>{!record?.busy_sync_error && <UpCircleTwoTone twoToneColor="#52c41a" />}</div>}
                </Popconfirm>
              )}
            </div>
            <div className="list__action">
              {!isPortrait && Helpers.getPermission(Helpers.permissionEntities.EXPENSES,
                Helpers.permissionTypes.UPDATE, user) && (
                  <div
                    className="list__actions-button"
                    onClick={() => {
                      setSelectedExpense(record);
                      setShowUpdateExpenseModal(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPen} />
                  </div>
                )}
              {/* <div */}
              {/*  className="list__actions-button list__actions-button-dark" */}
              {/*  onClick={() => { */}
              {/*    setSelectedExpense(record); */}
              {/*    setShowViewExpense(true); */}
              {/*  }} */}
              {/* > */}
              {/*  View */}
              {/* </div> */}
            </div>
          </div>
        ),
        fixed: 'right',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
    ];

    return payoutColumns.filter((item) => !item.hidden);
  };

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Expenses"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.EXPENSES, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ Record New Expense"
                      onClick={() => setShowAddExpenseModal(true)}
                      customClass="add-button"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    // temp states
                    setKeyword(tempFilterValues.keyword);
                    setSearchKeyword(tempFilterValues.keyword);
                    setLimit(tempFilterValues.limit);
                    setCurrentPage(1);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedSeller(Number(tempFilterValues.vendor) ? Number(tempFilterValues.vendor) : "");
                    getSellers('', user?.tenant_info?.tenant_id, 1, 1000, '', () => { }, true);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.EXPENSES}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search results for -
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}
                {selectedSeller && (
                  <Tag closable onClose={() => { setSelectedSeller(''); setCurrentPage(1); }} color="#2d7df7">
                    Selected Vendor -
                    &nbsp;
                    <span><b>{sellers?.sellers?.filter((item) => item.seller_id === Number(selectedSeller))?.[0]?.seller_info?.seller_name}</b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, ExpenseHome) => (
                  <div key={item}>
                    <Tag
                      closable
                      onClose={() => {
                        setCurrentPage(1);
                        setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                      }}
                      color="#2d7df7"
                    >
                      Business Unit -
                      &nbsp;
                      <span>
                        <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                      </span>
                    </Tag>
                  </div>
                ))}
              </div>
            </div>

            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${expense?.count || '0'} Expense`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="filters__buttons">
                        <Dropdown
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container filter__container-section">

                                <div className="filter__title"> Select Business Unit </div>

                                <TenantSelector
                                  selectedTenant={selectedTenant}
                                  showSearch
                                  onChange={(value) => {
                                    setSelectedTenant(value);
                                  }}
                                  placeholder="Select Business Unit"
                                  inputClassName="orgInputContainer"
                                  isMultiple
                                  hideTitle
                                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.EXPENSES, Helpers.permissionTypes.READ)}
                                />
                              </div>

                              <SelectSeller
                                selectedSeller={selectedSeller}
                                tenantId={selectedTenant}
                                onChange={(value) => {
                                  setSelectedSeller(value?.seller_id);
                                  setCurrentPage(1);
                                }}
                                customStyle={{}}
                                containerClass="filter__container filter__container-section"
                                inputClassName="no-class"
                                labelClassName="filter__title"
                                showAllSeller
                                mapSellerId
                              />

                            </div>
                          )}
                        >
                          <div className="action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        {/* <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                    Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                            localStorage.setItem('prcz-page-columns-payout', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                          Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                            <div key={key}>
                                              <Checkbox
                                                disabled={fixedColumns.includes(key)}
                                                checked={visibleColumns[key]?.visible}
                                                onChange={() => {
                                                  const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                                  visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                                  localStorage.setItem('prcz-page-columns-payout', JSON.stringify(visibleColumnsCopy));
                                                  setVisibleColumns(visibleColumnsCopy);
                                                }}
                                              >
                                                {visibleColumns[key]?.label}
                                              </Checkbox>
                                            </div>
                                          ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown> */}
                      </div>
                    </div>
                  </div>
                )}
                bordered
                showHeader
                loading={getExpenseLoading || pushExpenseToBusyLoading || savedFilterViewsLoading}
                size="small"
                columns={incomingPaymentsColumns()}
                dataSource={expense?.expenses || []}
                currentPage
                scroll={!isMobileOrPortrait && expense?.expenses?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!expense?.expenses?.length}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: expense ? expense?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
              />
            </div>
          </div>
        </div>
        <Drawer
          open={showViewExpense}
          onClose={() => setShowViewExpense(false)}
          width="880px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '825px' }}>
              <H3Text text={`View Expense #${selectedExpense?.exp_number}`} className="custom-drawer__title" />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => {
                  setShowViewExpense(false);
                }}
              />
            </div>
          </div>
          <ViewExpense
            selectedExpense={selectedExpense}
            selectedExpenseId={selectedExpense?.expense_id}
            onClose={() => {
              setShowViewExpense(false);
            }}
            callback={() => {
              setShowViewExpense(false);
              setCall(!call);
            }}
          />
        </Drawer>
      </div>
      <Drawer
        open={showAddExpenseModal}
        width="720px"
        mask
        onClose={() => setShowAddExpenseModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header">
            <H3Text text="Add New Expense" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowAddExpenseModal(false)} />
          </div>
        </div>
        <ExpenseForm
          callback={
            () => {
              setShowAddExpenseModal(false);
              setCall(!call);
            }
          }
        />
      </Drawer>
      <Drawer
        open={showUpdateExpenseModal}
        width="720px"
        mask
        onClose={() => setShowUpdateExpenseModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header">
            <H3Text text="Update Expense" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateExpenseModal(false)} />
          </div>
        </div>
        <ExpenseForm
          selectedExpense={selectedExpense}
          callback={
            () => {
              setShowUpdateExpenseModal(false);
              setCall(!call);
            }
          }
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, ExpenseReducers, SellerReducers, BusyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  sellers: SellerReducers.sellers,
  expense: ExpenseReducers.expense,
  getExpenseLoading: ExpenseReducers.getExpenseLoading,
  pushExpenseToBusyLoading: BusyIntegrationReducers.pushExpenseToBusyLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getExpense: (tenantId, expenseId, customerId, sellerId, departmentId, page, limit, status, startDate, endDate, searchKeyword) => dispatch(ExpenseActions.getExpense(tenantId, expenseId, customerId, sellerId, departmentId, page, limit, status, startDate, endDate, searchKeyword)),
  getTenants: (page, keyword, isVerified, orgId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId)),
  getSellers: (keyword, tenantId, page, limit) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit)),
  pushExpenseToBusy: (payload, callback) => dispatch(BusyIntegrationActions.pushExpenseToBusy(payload, callback)),
});

ExpenseHome.propTypes = {
  user: PropTypes.func,
  getExpense: PropTypes.func,
  getExpenseLoading: PropTypes.bool,
  history: PropTypes.func,
  expense: PropTypes.any,
  sellers: PropTypes.any,
  MONEY: PropTypes.func,
  pushExpenseToBusy: PropTypes.func,
  pushExpenseToBusyLoading: PropTypes.bool,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExpenseHome));
